export const formatStaffDisplayName = (employee) => {
  if (!employee) return 'Unknown';
  const fullName = `${employee.firstName || ''} ${employee.lastName || ''}`.trim();
  return fullName || employee.name || employee.employeeName || employee.email || 'Unknown';
};
